import { Card, CardContent, Typography, Box, Skeleton } from '@mui/material';
import { ReactNode } from 'react';

interface ChartCardProps {
  title: string;
  subtitle?: string;
  children: ReactNode;
  loading?: boolean;
  action?: ReactNode;
  height?: number;
}

/**
 * ChartCard - Wrapper card for charts
 *
 * Provides consistent styling and layout for chart components
 * - Title and optional subtitle
 * - Optional action button (e.g., export)
 * - Loading state with skeleton
 * - Configurable height
 */
export default function ChartCard({
  title,
  subtitle,
  children,
  loading,
  action,
  height = 400,
}: ChartCardProps) {
  return (
    <Card>
      <CardContent>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            mb: 2,
          }}
        >
          <Box>
            <Typography variant="h6" gutterBottom>
              {title}
            </Typography>
            {subtitle && (
              <Typography variant="body2" color="text.secondary">
                {subtitle}
              </Typography>
            )}
          </Box>
          {action && <Box>{action}</Box>}
        </Box>

        {loading ? (
          <Skeleton variant="rectangular" height={height} />
        ) : (
          <Box sx={{ height, width: '100%' }}>{children}</Box>
        )}
      </CardContent>
    </Card>
  );
}
